import { Level } from './level';

export class Hierarchy extends Level {

  buildModel() {
  }

  /*
   * Processes a cell and returns an array of objects with info and label.
   */
  readCell(cell, level_limit) {

    let result = [];
    let hie = this;

    for (let i = 0; i < this.levels.length; i++) {
      let levname = this.levels[i];
      let level = hie.dimension.getLevel(levname);
      let info = level.readCell(cell);
      if (info != null) result.push(info);

      // Stop if we reach level_limit
      if ((level_limit != undefined) && (level_limit != null)) {
        if (level_limit.name == levname) break;
      }
    }
    return result;
  }

  toString() {
    let id = this.dimension.name + '@' + this.name;
    if (this.levels) id = id + ':' + this.levels[this.levels.length - 1];
    return id;
  }

}



// WEBPACK FOOTER //
// ./src/common/hierarchy.js